export const FastlaneLink = ({onClick, text, logo}) => {
    return (
        <div
            className="fastlane-signup-link-container"
            onClick={onClick}>
            <span>{text}</span>
            <img className="fastlane-signup-img" src={logo}/>
        </div>
    )
}